const b = {
    loading: true,
    hotelDetails: {},
    error: '',
    // notificationData: {},
};
export default b;
